var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldValidationBadgeBw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46041",
    "data-name": "Group 46041",
    transform: "translate(-621.344 -35.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_54",
    "data-name": "Polygon 54",
    d: "M10.472,0,11.8,2.5l2.671.557L14.151,5.9,16,8l-1.849,2.1.321,2.843L11.8,13.5,10.472,16,8,14.8,5.528,16,4.2,13.5l-2.671-.557L1.849,10.1,0,8,1.849,5.9,1.528,3.056,4.2,2.5,5.528,0,8,1.2Z",
    transform: "translate(621.344 35.15)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46040",
    "data-name": "Group 46040",
    transform: "translate(625.54 40.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55487",
    "data-name": "Path 55487",
    d: "M99.73,12.484,101.373,14l4.213-4.281",
    transform: "translate(-98.854 -9.075)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldValidationBadgeBw);
export default __webpack_public_path__ + "static/media/field_validation_badge_bw.0dbaee781d1e8da608c7c5ed13dcff32.svg";
export { ForwardRef as ReactComponent };